import { render, staticRenderFns } from "./browse-configurations-list.view.vue?vue&type=template&id=8ac442e4&scoped=true"
import script from "./browse-configurations-list.view.vue?vue&type=script&lang=ts"
export * from "./browse-configurations-list.view.vue?vue&type=script&lang=ts"
import style0 from "./browse-configurations-list.view.vue?vue&type=style&index=0&id=8ac442e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac442e4",
  null
  
)

export default component.exports